// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1yDpq","title":"Header_title__2zwjc","left":"Header_left__13jHg","clinicName":"Header_clinicName__3pobd"};